import { useMemo } from 'react';

import type { DemographicStat } from '../../../../entities/post/models';
import type { TableColumnConfig } from '../../../../shared/components/data-table';
import { DataTable } from '../../../../shared/components/data-table';
import { TableHeader } from './table-header';

interface Props {
  genderData: DemographicStat[];
  onGenderClick?: (gender: DemographicStat, event: React.MouseEvent) => void;
  isLoading?: boolean;
}

export function GenderTable({ genderData, onGenderClick, isLoading }: Props) {
  const columns = useMemo(
    (): TableColumnConfig<DemographicStat>[] => [
      {
        key: 'name',
        header: 'Gender',
        size: 'auto',
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
      {
        key: 'postCount',
        header: 'Volume',
        size: '124px',
        enableSorting: true,
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
      {
        key: 'totalViews',
        header: 'Views',
        size: '124px',
        enableSorting: true,
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
      {
        key: 'totalLikes',
        header: 'Likes',
        size: '124px',
        enableSorting: true,
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
      {
        key: 'totalShares',
        header: 'Shares',
        size: '124px',
        enableSorting: true,
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
      {
        key: 'totalComments',
        header: 'Comments',
        size: '124px',
        enableSorting: true,
        cell: ({ getValue }) => <DataTable.Cell getValue={() => getValue()} />,
      },
    ],
    [],
  );

  const handleGenderClick = (gender: DemographicStat, event: React.MouseEvent) => {
    onGenderClick?.(gender, event);
  };

  return (
    <DataTable
      data={genderData}
      header={<TableHeader title="Gender" />}
      columns={columns}
      onRowClick={handleGenderClick}
      pageSize={10}
      minHeight="200px"
      isLoading={isLoading}
    />
  );
}
